import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=1ce4cc92&scoped=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=ts"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce4cc92",
  null
  
)

export default component.exports